import React, {useRef,useEffect} from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import styled from "styled-components";
import '../App.css';

const PowerBIWrapper = styled.div`
  width: 100%;
  height: 100%;
  max-height: 2000px; /* Adjust the maximum height as needed */
`;
const PowerBIReport = ({reportId,embedUrl,embedToken,width,height}) => {
    
    const iframeRef = useRef(null);
    useEffect(() => {
            // Access the iframe dimensions here
            if (iframeRef.current) {
              const iframeWidth = iframeRef.current.offsetWidth;
              const iframeHeight = iframeRef.current.offsetHeight;
        
            }
          }, [embedUrl,embedToken]);

    return (
        <PowerBIWrapper>
   <div
      style={{
        width: width,
        height: height,
        minHeight: '1000px' // Optional: Ensure a minimum height
      }}
    >
        <PowerBIEmbed
            embedConfig={{
              type: "report",
              id: reportId,
              embedUrl: embedUrl,
              accessToken: embedToken,
              tokenType: models.TokenType.Aad,
              pageView: "fitToPage",
              settings: {
                panes: {
                  filters: {
                    expanded: false,
                    visible: false,
                  },
                  pageNavigation: { visible: false },
                },
                background: models.BackgroundType.Transparent,
              },
            }}
            eventHandlers={
              new Map([
                [
                  "loaded",
                  function () {
                    console.log("Report loaded");
                  },
                ],
                [
                  "rendered",
                  function () {
                    console.log("Report rendered");
                  },
                ],
                [
                  "error",
                  function (event) {
                    console.log(event.detail);
                  },
                ],
                ["visualClicked", () => console.log("visual clicked")],
                ["pageChanged", (event) => console.log(event)],
              ])
            }
            cssClassName={"reportClass"}
            getEmbeddedComponent={(embeddedReport) => {
              window.report = embeddedReport;
            }}
            // Assign the ref to the iframe
            ref={iframeRef}
          />
        </div>
          </PowerBIWrapper>
    );
};

export default PowerBIReport